var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('GetSurvey',{model:{value:(_vm.survey),callback:function ($$v) {_vm.survey=$$v},expression:"survey"}}),_c('SurveyPermissions',{attrs:{"survey":_vm.survey}},[_c('div',{},[_c('SurveyAdminQuestions',{attrs:{"survey":_vm.survey}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }